import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setSingleCourse, setLoading } from "../../repository/slice";

function* getSingleCourseWorker({ payload }: any): SagaIterator {
    try {
        yield put(setLoading(true));
        const { data, message, isError }: IResponse<any> = yield call(requester.get, "/api/admin/courses/" + payload.id);
        if (isError) {

        } else {
            yield put(setSingleCourse(data));
        }
    } catch (error) {
        console.error("getSingleCourseWorker: ", error);
    } finally {
        yield put(setLoading(false));
    };
};

export function* getSingleCourseWatcher() {
    yield takeLatest("@saga/GET_SINGLE_COURSE", getSingleCourseWorker);
};
